import React, { useEffect, useState } from "react";
import {
  PlusOutlined,
  GithubOutlined,
  FileOutlined,
  FileTextOutlined,
  PaperClipOutlined,
  CloseOutlined,
  LinkOutlined,
} from "@ant-design/icons";
import { Button } from "antd";

const AttachmentsSection = ({ links, onAddLink }) => {
   const [attachments, setAttachments] = useState([]);

  // sync attachments whenever links prop changes
  useEffect(() => {
    setAttachments(links.map((att) => ({ ...att, color: randomSoftColor() })));
  }, [links]);

  const [showAddForm, setShowAddForm] = useState(false);

  const handleAdd = (linkData) => {
    if (onAddLink) onAddLink(linkData); // pass data to parent API handler
    setShowAddForm(false);
  };

  return (
    <div style={{ marginBottom: 24 }}>
      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          color: "#6b7280",
          fontSize: 13,
          marginBottom: 8,
          fontFamily: "Inter, sans-serif",
        }}
      >
        <PaperClipOutlined />
        <span>Attachments</span>
      </div>

      {/* Pills and Add Button */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
        {attachments.map((att, idx) => (
          <AttachmentPill
            key={idx}
            id={att.id}
            label={att.label}
            url={att.url}
            color={att.color}
          />
        ))}

        {!showAddForm && (
          <div
            onClick={() => setShowAddForm(true)}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 6,
              padding: "4px 10px",
              borderRadius: 9999,
              border: "1px dashed #d1d5db",
              color: "#3b82f6",
              cursor: "pointer",
              fontSize: 13,
              fontFamily: "Inter, sans-serif",
              marginBottom: 4,
            }}
          >
            <PlusOutlined />
            Add
          </div>
        )}
      </div>

      {/* Inline Add Form */}
      {showAddForm && (
        <AddAttachmentForm
          onAdd={handleAdd}
          onCancel={() => setShowAddForm(false)}
        />
      )}
    </div>
  );
};

// Generate a random soft pastel color
const randomSoftColor = () => {
  const colors = ["#dbeafe", "#fef3c7", "#fee2e2", "#dcfce7", "#ede9fe"];
  return colors[Math.floor(Math.random() * colors.length)];
};

// Determine icon based on URL
const getAttachmentIcon = (url) => {
  if (!url) return <LinkOutlined />;
  const lower = url.toLowerCase();
  if (lower.includes("github")) return <GithubOutlined />;
  if (lower.includes("docs.google")) return <FileTextOutlined />; // Google Docs placeholder
  return <LinkOutlined />;
};

// Inline Add Form with cancel button
const AddAttachmentForm = ({ onAdd, onCancel }) => {
  const [label, setLabel] = useState("");
  const [url, setUrl] = useState("");

  const handleAdd = () => {
    if (!label || !url) return;
    onAdd({ label, url });
    setLabel("");
    setUrl("");
  };

  return (
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 8 }}>
      <input
        style={{
          flex: 1,
          padding: 6,
          borderRadius: 6,
          border: "1px solid #d1d5db",
          fontFamily: "Inter, sans-serif",
        }}
        placeholder="Label"
        value={label}
        onChange={(e) => setLabel(e.target.value)}
      />
      <input
        style={{
          flex: 2,
          padding: 6,
          borderRadius: 6,
          border: "1px solid #d1d5db",
          fontFamily: "Inter, sans-serif",
        }}
        placeholder="URL"
        value={url}
        onChange={(e) => setUrl(e.target.value)}
      />
      <Button
        onClick={handleAdd}
        style={{
          backgroundColor: "#3b82f6",
          color: "#fff",
          border: "none",
          borderRadius: 6,
          cursor: "pointer",
          fontFamily: "Inter, sans-serif",
          fontSize: 12,
        }}
      >
        Save
      </Button>
      <Button
        onClick={onCancel}
        type="dashed"
        style={{
          cursor: "pointer",
          fontFamily: "Inter, sans-serif",
          fontSize: 12,
        }}
      >
        Cancel
      </Button>
    </div>
  );
};

// Attachment pill with persistent color
const AttachmentPill = ({ id, label, url, color }) => (
  <a
    href={url}
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      padding: "4px 10px",
      borderRadius: 4,
      backgroundColor: color,
      fontSize: 11,
      fontFamily: "Inter, sans-serif",
      textDecoration: "none",
      color: "#111827",
      marginBottom: 4,
    }}
  >
    {getAttachmentIcon(url)}
    <span>{label}</span>
  </a>
);

export default AttachmentsSection;
